import { DateTime } from 'luxon'
import { DATE_FORMATS_LUXON } from '@/utils/dateHelpers'
import { FC, useState } from 'react'
import {
  Button,
  Dropdown,
  Modal,
  Text,
} from '../../../deprecated-components/BaseComponents'

interface Props {
  onClose: () => void
  onCreateReports: (_year: string) => Promise<void>
  loading: boolean
}

const GenerateMissingReportsModal: FC<Props> = ({
  onClose,
  onCreateReports,
  loading,
}) => {
  const [selectedOption, setSelectedOption] = useState('')

  const now = DateTime.now()
  const years = Array.from({ length: 5 }, (_, i) =>
    now.minus({ years: i }).toFormat(DATE_FORMATS_LUXON.YEAR_FOUR_DIGIT)
  )
  const options = years.map((year) => ({
    key: year,
    value: year,
    text: year,
  }))

  return (
    <Modal open onClose={onClose}>
      <Modal.Header>Generate Missing Reports</Modal.Header>
      <Modal.Content>
        <Modal.Description>
          <Text as="h1">Choose a starting year</Text>
          <Text style={{ padding: '1em' }}>
            Any <b>missing books</b> from January of the selected year through
            the current month will be generated.
          </Text>
          <Dropdown
            options={options}
            onChange={setSelectedOption}
            value={selectedOption}
          />
        </Modal.Description>
      </Modal.Content>
      <Modal.Actions>
        <Button variant="actionLink" onClick={onClose}>
          Cancel
        </Button>
        <Button
          variant="primary"
          disabled={loading || !selectedOption}
          loading={loading}
          onClick={() => onCreateReports(selectedOption)}
          content="Generate"
        />
      </Modal.Actions>
    </Modal>
  )
}

export default GenerateMissingReportsModal
